import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLlmAside = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" className="icon-llm-aside" data-icon="icon-llm-aside" aria-hidden="true" {...props} ref={ref}><path d="M8.25 4.5V19.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/><path d="M20.25 4.5H3.75C3.33579 4.5 3 4.83579 3 5.25V18.75C3 19.1642 3.33579 19.5 3.75 19.5H20.25C20.6642 19.5 21 19.1642 21 18.75V5.25C21 4.83579 20.6642 4.5 20.25 4.5Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/></svg>);
});

IconLlmAside.displayName = 'IconLlmAside';
